"use client";
import React from "react";
import { Button } from "@shared/src/components/ui/button";
import { cn } from "@shared/src/utils/cn";
import { DropdownMenuItem } from "@shared/src/components/ui/dropdown-menu";
import Link from "next/link";
import { usePathname } from "next/navigation";

export const COMMON_STYLES = {
  menuItem: "py-3 px-6 focus:bg-surfaces-bg-hover rounded-xl cursor-pointer",
  dropdownContent: "bg-surfaces-bg-primary border-border-secondary rounded-2xl",
  divider: "h-6 w-px bg-surfaces-bg-tertiary",
} as const;

export function IconButton({ children, className, size, ...props }: React.ComponentProps<typeof Button>) {
  const buttonSize = size === "icon" ? "square" : size || "md";
  return (
    <Button
      variant="surface-secondary"
      size={buttonSize as any}
      radius="full"
      className={cn("px-3", className)}
      {...props}
    >
      {children}
    </Button>
  );
}

export function MenuDivider({ className }: { className?: string }) {
  return <div className={cn(COMMON_STYLES.divider, className)} />;
}

export function MenuItem({
  href,
  icon: Icon,
  label,
  className,
  onSelect,
  isExternal,
}: {
  href: string;
  icon: React.ComponentType<{ size?: number }>;
  label: string;
  className?: string;
  onSelect?: () => void;
  isExternal?: boolean;
}) {
  const pathname = usePathname();
  return (
    <DropdownMenuItem variant="large" className={className} onSelect={onSelect} asChild>
      {isExternal ? (
        <a href={href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 w-full">
          <Icon size={20} />
          <span className="text-text-primary">{label}</span>
        </a>
      ) : (
        <Link href={href} className="flex items-center gap-3 w-full">
          <Icon size={20} />
          <span
            className={
              pathname === href
                ? "text-text-primary font-bold brightness-125"
                : "text-text-secondary hover:text-text-primary"
            }
          >
            {label}
          </span>
        </Link>
      )}
    </DropdownMenuItem>
  );
}
